import { useEffect, useState } from "react";
import Select from "../Components/CommonCommponents/select/Select";
import { Progress, Modal } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useForm } from "react-hook-form";
import { useRef } from "react";
import { Button as AntdButton, Button, Upload } from "antd";
import DocumentUpload from "./documentUpload";
import deleteIcon from "../Assets/Icons/delete.svg";
import CandodateService from "../Service.js/CandidateService";
import confirmIcon from "../Assets/Icons/confirmSheet.png";
import toast from "react-hot-toast";
import lockIcon from "../Assets/Icons/lockIcon.svg";
import { Image } from "antd";
import { Document, Page, pdfjs } from "react-pdf";
import { useParams } from "react-router-dom";
import { getFileType } from "../Utils/utils";
import DocumentViewer from "../Components/CommonCommponents/DocumentViewer";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const CandidateDouments = () => {
  const { jobId } = useParams();
  console.log("jobId", jobId);
  const [isOpen, setOpen] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [isConfirm, setIsConfirm] = useState(false);
  const [isView, setIsView] = useState(false);
  const [documentDetails, setDocumentDetails] = useState();
  const [selectedFile, setSelectedFile] = useState();
  const [numPages, setNumPages] = useState(null);
  const [ListCandidate, setListCandidate] = useState();
  const [pageNumber, setPageNumber] = useState();
  const [candidateId, setCandidateId] = useState();

  const {
    register,
    control,
    setValue,
    setError,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const contactInfo = async () => {
    await CandodateService.candidateContactDetails()
      .then((response) => {
        setCandidateId(response?.data?.data?.candidate_details_id);
      })
      .catch((error) => {});
  };

  const getDocumentDetails = async () => {
    await CandodateService.getDocuments(jobId, candidateId)
      .then((response) => {
        setDocumentDetails(response.data.data);
      })
      .catch((error) => {});
  };
  const handleConfirm = async () => {
    await CandodateService.confirmDocument(checkedItems)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Document is Confirmed!");
          setIsConfirm(false);
          setCheckedItems([]);
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };
  useEffect(() => {
    contactInfo();
  }, []);
  useEffect(() => {
    getDocumentDetails();
  }, [isOpen, isConfirm, candidateId]);
  const handleChange = (e, itemId) => {
    setCheckedItems((prevItems) => {
      if (e.target.checked) {
        // If checkbox is checked, add the item ID to the array
        return [...prevItems, itemId];
      } else {
        // If checkbox is unchecked, remove the item ID from the array
        return prevItems.filter((id) => id !== itemId);
      }
    });
  };
  const handleDelete = async (id) => {
    await CandodateService.deleteDocument(id, jobId)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Deleted!");
          getDocumentDetails();
        },
        (error) => {
          toast.error("Failed To Delete");
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Delete");
      });
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };
  const handleViewFile = (item) => {
    setIsView(true);
    setSelectedFile(item);
  };
  const fileType = getFileType(selectedFile?.document_absolute_url);
  return (
    <div className="pageContent w-full scrollbar-hide ">
      <div className="mt-12 chart_div">
        <div className="w-1/2 ">
          <p className="text-2xl font-semibold">My Documents</p>
          <div className="rounded-xl border-dashed border-2 border-gray-400 bg-white p-4 mt-8">
            <div className="flex justify-center items-center mt-14">
              <button
                onClick={() => setOpen(true)}
                className="rounded-3xl border border-black bg-white mx-auto mt-4 p-3"
              >
                Upload Document
              </button>
            </div>
            <p className="flex justify-center items-center ant-upload-text pt-4">
              Reference Documents are passport, License Aadhar card, Pan card
              etc.
            </p>
            <p className="flex justify-center items-center ant-upload-text pt-2 mb-14">
              Supported Formats: doc, docx, rtf, pdf, upto 2 MB
            </p>
          </div>
        </div>
        <div className="w-1/2 mt-10">
          <p className="text-gray-700 font-poppins text-xl font-medium">
            {documentDetails?.results.length > 0 ? "Documents" : ""}
          </p>

          {documentDetails?.results?.length > 0 &&
            documentDetails?.results?.map((item, index) => {
              const formattedContactDetails = item?.updated.split("T")[0];
              const documenturl = item?.document_absolute_url.split("/");
              const uploadeFile = documenturl[documenturl.length - 1];
              console.log("documenturl", uploadeFile);
              return (
                <div>
                  <div className="flex flex-wrap justify-between mt-6">
                    <div className="flex">
                      {item.status === "NOT_CONFIRM" && (
                        <input
                          id={item.id}
                          type="checkbox"
                          className="w-5 bg-[#000]"
                          onChange={(e) => {
                            handleChange(e, item.id);
                          }}
                        />
                      )}
                      {item.status === "CONFIRM" && (
                        <img src={lockIcon} alt="lockicon" className="w-4" />
                      )}
                      <p className="pl-6 text-medium font-medium mt-1">
                        {item?.document_type_readable}
                      </p>
                    </div>
                    <div className="flex">
                      {item.status === "NOT_CONFIRM" && (
                        <button onClick={() => handleDelete(item.id)}>
                          <img src={deleteIcon} alt="sefg" className="pr-6 " />
                        </button>
                      )}

                      {item.status === "NOT_CONFIRM" && (
                        <button className="rounded-full bg-[#F19292] px-4 text-white text-medium font-medium leading-normal">
                          Not Confirm
                        </button>
                      )}
                      {item.status === "CONFIRM" && (
                        <button className="rounded-full bg-[#53A994] px-4 p-2 text-white text-medium font-medium leading-normal">
                          Confirmed
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="flex flex-wrap">
                    <button
                      onClick={() => handleViewFile(item)}
                      className="pl-10 text-gray-600 font-poppins text-base font-normal  underline "
                    >
                      {uploadeFile}
                    </button>
                    <p className="mx-4 divider">|</p>
                    <p className="text-gray-600 font-poppins text-base font-normal ">
                      Uploaded on {formattedContactDetails}
                    </p>
                  </div>
                  <div className="h-[1px] bg-[#DEDEDE] w-full mt-8"></div>
                </div>
              );
            })}

          {checkedItems?.length ? (
            <div className="flex justify-end mt-10 mb-10">
              <div className="">
                <Button
                  onClick={() => setIsConfirm(true)}
                  className="rounded-full border border-solid border-black text-white bg-[#0A0A0A]"
                >
                  Confirm
                </Button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {isOpen && (
        <Modal
          open={isOpen}
          title="Upload Documents"
          footer={null}
          width={700}
          onCancel={() => setOpen(false)}
          className="addCandidatesModal"
        >
          <DocumentUpload
            jobId={jobId}
            candidateId={candidateId}
            close={() => setOpen(false)}
          />
        </Modal>
      )}
      {isConfirm && (
        <Modal
          open={isConfirm}
          title="Upload Documents"
          footer={null}
          width={700}
          onCancel={() => setIsConfirm(false)}
          className="addCandidatesModal"
        >
          <form>
            <div className="flex flex-wrap items-center justify-center mt-10">
              <div>
                <div className="">
                  <img src={confirmIcon} alt="browserWindowIcon" />
                </div>
                <div className="flex flex-wrap items-center justify-center mt-4 px-6">
                  <p className="text-black font-poppins text-2xl font-bold">
                    Are you sure?
                  </p>
                </div>
                <div className="flex flex-wrap items-center justify-center mt-4 px-6">
                  <p className="text-gray-600 text-center font-poppins text-base font-normal">
                    {" "}
                    Are you sure you want to confirm
                    <br />
                    with this document?
                  </p>
                </div>
                <div className="flex flex-wrap items-center justify-center mt-16 px-6 mb-16">
                  <div className="flex flex-wrap justify-between">
                    <div className="px-6">
                      <Button
                        onClick={() => handleConfirm()}
                        className="text-black rounded-full border border-black font-poppins text-base font-semibold"
                      >
                        Yes
                      </Button>
                    </div>
                    <div>
                      <Button
                        onClick={() => setIsConfirm(false)}
                        className="rounded-full bg-black text-white font-poppins text-base font-semibold"
                      >
                        No
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal>
      )}
      {isView && (
        <Modal
          open={isView}
          title=""
          footer={null}
          width={700}
          onCancel={() => setIsView(false)}
          className="addCandidatesModal"
        >
          <div className="flex flex-wrap items-center justify-center mt-10">
            {fileType === "pdf" ? (
              <Document
                file={selectedFile?.document_absolute_url}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                <Page pageNumber={pageNumber} />
              </Document>
            ) : (
              <DocumentViewer
                fileUrl={selectedFile?.document_absolute_url}
                fileType={fileType}
              />
            )}
          </div>
        </Modal>
      )}
    </div>
  );
};
export default CandidateDouments;
